import { render, staticRenderFns } from "./inPurchasingLowPrice.vue?vue&type=template&id=79961af0&scoped=true"
import script from "./inPurchasingLowPrice.vue?vue&type=script&lang=js"
export * from "./inPurchasingLowPrice.vue?vue&type=script&lang=js"
import style0 from "./inPurchasingLowPrice.vue?vue&type=style&index=0&id=79961af0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79961af0",
  null
  
)

export default component.exports